export default "__VITE_ASSET__46c64c1e__"